module.exports = __webpack_public_path__ + "media/images/emoticons/upwardright-90824de82dab9b739fb796d2f81f0798.gif";